import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { QueueJob } from './queue-job.model';

export const postQueueJob = createAction(
    '[Job/API] POST QueueJob',
    props<{
        employeelistid: string;
        customerid: string;
        jobid: string;
        storedproc?: string;
    }>()
);

export const loadQueueJobs = createAction(
    '[QueueJob/API] Load QueueJobs',
    props<{ QueueJobs: any[] }>()
);

export const addQueueJob = createAction(
    '[QueueJob/API] Add QueueJob',
    props<{ QueueJob: QueueJob }>()
);

export const upsertQueueJob = createAction(
    '[QueueJob/API] Upsert QueueJob',
    props<{ QueueJob: QueueJob }>()
);

export const addQueueJobs = createAction(
    '[QueueJob/API] Add QueueJobs',
    props<{ QueueJobs: QueueJob[] }>()
);

export const upsertQueueJobs = createAction(
    '[QueueJob/API] Upsert QueueJobs',
    props<{ QueueJobs: QueueJob[] }>()
);

export const updateQueueJob = createAction(
    '[QueueJob/API] Update QueueJob',
    props<{ QueueJob: Update<QueueJob> }>()
);

export const updateQueueJobs = createAction(
    '[QueueJob/API] Update QueueJobs',
    props<{ QueueJobs: Update<QueueJob>[] }>()
);

export const deleteQueueJob = createAction(
    '[QueueJob/API] Delete QueueJob',
    props<{ id: string }>()
);

export const deleteQueueJobs = createAction(
    '[QueueJob/API] Delete QueueJobs',
    props<{ ids: string[] }>()
);

export const clearQueueJobs = createAction('[QueueJob/API] Clear QueueJobs');
